module.exports = __webpack_public_path__ + "img/eye-closed.2b5cc19b.svg";